import { CityState, DataSource, HorizontalSpacer, Label, Layout, Map, Panel, SearchButton, Splitter, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOpportunityFindNear extends Layout {
    buttonSearch: SearchButton;
    citystateNear: CityState;
    horizontalspacer1: HorizontalSpacer;
    labelFindOpportunitiesWithType: Label;
    labelMilesOf: Label;
    labelWithin: Label;
    mapFindNear: Map;
    panelSearch: Panel;
    sourceOpportunity: DataSource;
    splitterMap: Splitter;
    switchPlotOnMap: Switch;
    tableFindNear: Table;
    textboxFindNearRadius: Textbox;
    textboxStatus: Textbox;
}
